import { IS_PROD_US } from '@cast/constants';
import { useTrial } from '@cast/shared-trial-ui';

import { useHubspotContact } from 'core/hubspot';

/**
 * Whether the first-login contacts form is showing or about to show.
 *
 * The first-login contacts form takes over the whole screen (App.tsx swaps
 * the router outlet for it). While the HubSpot contact is still 'pending'
 * the form is showing or about to show, so hold off. Once the form is
 * finished (contact submitted, or suppressed by trial eligibility) the
 * outlet is swapped back and the page re-mounts, and deferred UI can open
 * then instead of stacking on top of the form.
 */
export const useIsContactsFormActive = (): boolean => {
  const { contactState } = useHubspotContact();
  const { isEligible } = useTrial();

  return IS_PROD_US && contactState === 'pending' && isEligible !== true;
};
